import React from 'react'
import './style.scss'
import ReactLoading from 'react-loading'

function Button({ load, name = 'SALVAR', icon, loaderColor: customLoaderColor, ...props }) {
    const isDarkMode = document.body.classList.contains('dark-mode') || document.body.getAttribute('data-theme') === 'dark';
    const loaderColor = customLoaderColor || (isDarkMode ? '#2F3437' : '#FFFFFF');

    return (
        <>
            <button disabled={load ? load : false} {...props} className={`btn btn-block waves-effect waves-light ${props.className || 'btn-primary'}`} type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                {
                    load ?
                        <ReactLoading type='cylon' color={loaderColor} height={30} width={30} />
                        :
                        <>
                            {
                                name
                            }
                            {
                                icon && icon
                            }
                        </>
                }
            </button>
        </>
    )
}

export default Button